module.exports = __webpack_public_path__ + "static/media/38-marco.da1b74d5.jpg";